import type { Contagens } from '../types';

interface Props {
  contagens: Contagens;
}

const ITENS = [
  { chave: 'criancas', rotulo: 'Crianças' },
  { chave: 'familias', rotulo: 'Famílias' },
  { chave: 'completos', rotulo: 'Com termo assinado' },
  { chave: 'faltam', rotulo: 'Faltam' },
] as const;

// Os quatro números do topo: branco, cantos de 16 px.
export default function Numeros({ contagens }: Props) {
  return (
    <section className="grid grid-cols-2 gap-2.5 rounded-2xl border border-background-200 bg-white p-4 sm:grid-cols-4">
      {ITENS.map((item) => (
        <div key={item.chave} className="min-w-0">
          <p className="text-[20px] font-extrabold leading-none tabular-nums text-foreground-950">
            {contagens[item.chave]}
          </p>
          <p className="mt-1 text-[12px] leading-tight text-foreground-600">{item.rotulo}</p>
        </div>
      ))}
    </section>
  );
}